import debounce from "lodash/debounce";

// Screen enum pushed to the embedded Rocky chatbot via the
// `ai-writer-screen-ready` postMessage. Keep in sync with
// lib/ai-writer-screens.js on the Rocky side.
export const SCREENS = {
  CONFIG: "config",
  OUTLINE_BUILDER: "outline_builder",
  GENERATING: "generating",
  VARIANT_TITLE: "variant_title",
  VARIANT_PAGE_TITLE: "variant_pageTitle",
  VARIANT_SUBHEADINGS: "variant_subHeadings",
  VARIANT_PARAGRAPH: "variant_paragraph",
  RICH_CONTENT: "rich_content",
  IMAGE_PLACEHOLDER: "image_placeholder",
  CONTENT_EDITOR_OUTLINE: "content_editor_outline",
  CONTENT_EDITOR_AI_DRAFT: "content_editor_ai_draft",
  CONTENT_EDITOR_HUMAN: "content_editor_human",
  SHOW_HEAD_EDITOR: "show_head_editor",
  SCORE_PANEL: "score_panel",
  DOWNLOAD_EXPORT: "download_export",
};

// Rocky compares/recommends on variant previews; it never pastes full copy
// back into chat, so strip markup and cap the length (~200 chars).
export function rockyTruncate(str, n = 200) {
  if (str === null || str === undefined) return "";
  const text = String(str)
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  return text.length > n ? text.slice(0, n) : text;
}

// Shared plumbing for emitting `ai-writer-screen-ready` to Rocky. Mixed into
// both the AI Writer (AI-mode screens) and the FullPageSourceEditorV2 parent
// (content-editor chrome). Mirrors the prior-art `wizard-chips-ready` pattern.
export default {
  created() {
    // Per-instance so two editor instances never share a debounce timer.
    this._emitRockyScreenDebounced = debounce((arg) => {
      const payload = typeof arg === "function" ? arg() : arg;
      this.emitRockyScreen(payload);
    }, 1200);
  },
  beforeDestroy() {
    if (this._emitRockyScreenDebounced) {
      this._emitRockyScreenDebounced.cancel();
    }
  },
  methods: {
    emitRockyScreen(payload) {
      if (!payload || !payload.screen) return;
      // Mirror identifying fields into Vuex so pop-context (sent from
      // PopAssistantButton, which has no ref back to the editor) can read the
      // pieces that don't live in the route URL.
      this.$store.commit("setRockyReadback", {
        screen: payload.screen,
        activeScreen: payload.screen,
        sourceType: payload.sourceType ?? null,
        editorMode: payload.editorMode ?? null,
        aiRunId: payload.aiRunId ?? null,
        pageRunId: payload.pageRunId ?? null,
      });
      this.$root.$refs.popAssistantButton?.postToIframe(
        "ai-writer-screen-ready",
        payload
      );
    },
    // Accepts either a payload object or a builder function (deferred so the
    // payload is assembled once, when the debounce actually fires).
    emitRockyScreenDebounced(builderOrPayload) {
      if (this._emitRockyScreenDebounced) {
        this._emitRockyScreenDebounced(builderOrPayload);
      }
    },
  },
};
